import style from './Sidebar.module.scss';
import className from 'classnames/bind';
import {memo, useMemo, useState} from "react";
import {Menu} from "antd";
import {useLocation, Link} from "react-router-dom";
import {Image, FontAwesomeIcon} from "~/components";
import {useGetMySubscriptionQuery} from "~/reduxs/api/subscriptionApiSlice";
import ProfileRow from "./ProfileRow";
import {NavBarData} from "./NavBarData";
import findActiveKey from "./findActiveKey";
import images from "../../assets/images";

const cn = className.bind(style);

// Số hotline hỗ trợ
const HOTLINE = '028 6287 3865';

/**
 * Sidebar CHẾ ĐỘ NGƯỜI DÙNG: logo → hồ sơ (ProfileRow) → thẻ gói/token →
 * menu công cụ SEO → khung hỗ trợ. Thu gọn (collapsed) = icon-rail.
 */
function Sidebar({onNavigate, collapsed = false})
{
	const location = useLocation();

	// Gói + token còn lại của user (hiển thị ở sidebar).
	const {data: sub} = useGetMySubscriptionQuery();

	// Trạng thái mở/thu gọn các nhóm menu (submenu). Module nghiệp vụ mới có thể
	// thêm key mặc định mở vào mảng này.
	const [openKeys, setOpenKeys] = useState([]);

	const navBarList = NavBarData();

	const moduleActive = useMemo(
		() => findActiveKey(navBarList, location.pathname),
		[location.pathname, navBarList]
	);

	// Thông tin gói + token còn lại cho thẻ ở sidebar.
	const nf = (n) => Number(n || 0).toLocaleString('vi-VN');
	const isRootUser = Boolean(sub?.is_root);
	const ownKeyUser = Boolean(sub?.require_own_ai_key);
	const tk = sub?.ai_tokens || {};
	const tkPct = tk.limit > 0 ? Math.min(100, Math.round(((tk.used || 0) / tk.limit) * 100)) : 0;

	return (
		<div className={cn('sidebar', {collapsed})}>
			{/* Logo */}
			<div className={cn('logo')}>
				<Image src={images.logo} alt="Omni SEO" />
			</div>

			{/* Hồ sơ: avatar - tên - chức vụ + chuông thông báo (thu gọn: chỉ còn avatar) */}
			<ProfileRow onNavigate={onNavigate} collapsed={collapsed} />

			{/* Thẻ Gói & token còn lại → tới trang Gói & Hạn mức */}
			{!collapsed && sub && (
				<Link to="/subscription" className={cn('plan-box')} data-plan={sub.plan?.slug} onClick={onNavigate}>
					<div className={cn('plan-box-head')}>
						<span className={cn('plan-box-name')}>
							<FontAwesomeIcon icon="fa-light fa-crown" /> {sub.plan?.name || 'Miễn phí'}
						</span>
						<FontAwesomeIcon icon="fa-light fa-arrow-up-right-from-square" className={cn('plan-box-go')} />
					</div>
					{isRootUser ? (
						<div className={cn('plan-box-line')}><span>AI Token</span><strong>Không giới hạn</strong></div>
					) : ownKeyUser ? (
						<div className={cn('plan-box-line')}><span>AI Token</span><strong>Khoá riêng</strong></div>
					) : (
						<>
							<div className={cn('plan-box-line')}>
								<span>Token còn lại</span>
								<strong>{nf(tk.remaining)}</strong>
							</div>
							<div className={cn('plan-box-bar')}>
								<div className={cn('plan-box-fill')} style={{width: `${tkPct}%`}} />
							</div>
						</>
					)}
				</Link>
			)}

			{/* Menu điều hướng. Gotcha antd: khi inlineCollapsed không được truyền
			    controlled openKeys (antd cảnh báo + tự quản popup submenu). */}
			<div className={cn('menu')}>
				<Menu
					mode="inline"
					inlineCollapsed={collapsed}
					selectedKeys={[moduleActive]}
					{...(!collapsed && {openKeys, onOpenChange: setOpenKeys})}
					items={navBarList}
					onClick={onNavigate}
					style={{borderInlineEnd: 'none', background: 'transparent'}}
				/>
			</div>

			{/* Khung hỗ trợ */}
			{!collapsed && (
				<div className={cn('support')}>
					<div className={cn('support-inner')}>
						<div className={cn('support-icon')}>
							<FontAwesomeIcon icon="fa-light fa-headset" />
						</div>
						<p className={cn('support-title')}>Bạn cần hỗ trợ?</p>
						<p className={cn('support-desc')}>Liên hệ hotline để được trợ giúp</p>
						<a href={`tel:${HOTLINE.replace(/\s/g, '')}`} className={cn('support-hotline')}>
							<FontAwesomeIcon icon="fa-light fa-phone-volume" />
							<span>{HOTLINE}</span>
						</a>
					</div>
				</div>
			)}
		</div>
	);
}

export default memo(Sidebar);
